import { API_URL } from '../config/api';

/** Uploaded photos are stored as "/api/users/avatar/…"; they live on the API host, not the app host. */
export function avatarSrc(avatar) {
  const value = String(avatar || '').trim();
  if (!value) return '';
  if (/^https:\/\//i.test(value)) return value;
  if (value.startsWith('/api/')) {
    try {
      return new URL(API_URL, window.location.origin).origin + value;
    } catch {
      return value;
    }
  }
  return '';
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('Could not read this image'));
    img.src = src;
  });
}

/** Draws the chosen crop area onto a square canvas and returns a JPEG blob. */
export async function cropToBlob(imageSrc, area, size = 512) {
  const img = await loadImage(imageSrc);
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, size, size);
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(img, area.x, area.y, area.width, area.height, 0, 0, size, size);
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('Could not crop this image'))), 'image/jpeg', 0.9);
  });
}
